import { postAnalyticsEvent, getParsePointersForSelectedTicket } from './common';

const ORDER_CANCELLATION = 'ORDER_CANCELLATION';
const RETURN_ORDER = 'RETURN_ORDER';

export const trackOrderCancellation = async (params) => {
  const parsePointers = getParsePointersForSelectedTicket();
  await postAnalyticsEvent(ORDER_CANCELLATION, parsePointers, params);
};

export const returnOrder = async (conversationObjectId) => {
  const parsePointers = {
    conversationPtr: conversationObjectId,
  };
  await postAnalyticsEvent(RETURN_ORDER, parsePointers);
};
